import React, { useContext } from "react";

import { SPopupContext } from "App/common/hoc/SlidingPopup";
import { useHotKeys } from "App/common/hooks/hotKeys";
import { outlineFocus } from "utils";

function SmtpSettings(props) {
  const { sPopupState } = useContext(SPopupContext);

  function updateValidation(type) {
    if (sPopupState.validation.params) {
      switch (type) {
        case "username":
          if (sPopupState.validation.params.username) {
            sPopupState.validation.params.username.check = false;
            sPopupState.validation.params.username.msg = "";
          }
          break;
        case "password":
          if (sPopupState.validation.params.password) {
            sPopupState.validation.params.password.check = false;
            sPopupState.validation.params.password.msg = "";
          }
          break;
        case "servername":
          if (sPopupState.validation.params.servername) {
            sPopupState.validation.params.servername.check = false;
            sPopupState.validation.params.servername.msg = "";
          }
          break;
        case "port":
          if (sPopupState.validation.params.port) {
            sPopupState.validation.params.port.check = false;
            sPopupState.validation.params.port.msg = "";
          }
          break;
        default:
          break;
      }
    }
  }

  return (
    <div className="smpt_settings">
      <div className="sub_title">SMTP Settings</div>
      <div className="en_inpt just_flex">
        <div
          className="check"
          onChange={() =>
            props.changeNotificationSMTPSetting(
              "isEnabled",
              !props.smtpSettings.isEnabled
            )
          }
        >
          <input
            type="checkbox"
            className={
              "input_checkbox" +
              (props.smtpSettings.isEnabled && window.browserName === "ie"
                ? " ie_checked"
                : "")
            }
            id="smtp_enable"
            defaultChecked={props.smtpSettings.isEnabled}
            tabIndex={0}
            visibility="block"
            onFocus={() => {
              outlineFocus("smtp_enable_label", 1);
            }}
            onBlur={() => {
              outlineFocus("smtp_enable_label", 0);
            }}
          />

          <label htmlFor="smtp_enable" id="smtp_enable_label"></label>
        </div>
        <p
          className="checkbox_p"
          onClick={() =>
            props.changeNotificationSMTPSetting(
              "isEnabled",
              !props.smtpSettings.isEnabled
            )
          }
        >
          Custom SMTP settings
        </p>
      </div>
      <div
        className={[
          "smpt_form",
          props.smtpSettings.isEnabled ? "" : "transparent_layer_wrap"
        ].join(" ")}
      >
        <div
          className="transparent_layer"
          style={{ display: props.smtpSettings.isEnabled ? "none" : "block" }}
        ></div>
        <div className="ens_wrap">
          <div className="ens_item">
            <p>Server Name</p>
            <div className="err_msg_wrap">
              <input
                type="text"
                className="input_text"
                value={props.smtpSettings.serverName}
                onChange={e =>
                  props.changeNotificationSMTPSetting(
                    "serverName",
                    e.target.value
                  ) && updateValidation("servername")
                }
                tabIndex={props.smtpSettings.isEnabled ? 0 : -1}
              />
              {props.smtpSettings.isEnabled &&
                !sPopupState.validation.status &&
                sPopupState.validation.params.servername && (
                  <div>
                    <span className="error-msg active">
                      {sPopupState.validation.params.servername.msg}
                    </span>
                  </div>
                )}
            </div>
          </div>
          <div className="ens_item">
            <p>Port</p>
            <div className="err_msg_wrap">
              <input
                type="number"
                className="input_number"
                value={props.smtpSettings.port}
                onChange={e =>
                  props.changeNotificationSMTPSetting("port", e.target.value) &&
                  updateValidation("port")
                }
                tabIndex={props.smtpSettings.isEnabled ? 0 : -1}
              />
              {props.smtpSettings.isEnabled &&
                !sPopupState.validation.status &&
                sPopupState.validation.params.port && (
                  <div>
                    <span className="error-msg active">
                      {sPopupState.validation.params.port.msg}
                    </span>
                  </div>
                )}
            </div>
          </div>
        </div>
        <div className="ens_wrap">
          <div className="ens_item">
            <p>Username</p>
            <div className="err_msg_wrap">
              <input
                type="text"
                className="input_text"
                value={props.smtpSettings.userName}
                onChange={e =>
                  props.changeNotificationSMTPSetting(
                    "userName",
                    e.target.value
                  ) && updateValidation("username")
                }
                tabIndex={props.smtpSettings.isEnabled ? 0 : -1}
              />
              {props.smtpSettings.isEnabled &&
                !sPopupState.validation.status &&
                sPopupState.validation.params.username && (
                  <div>
                    <span className="error-msg active">
                      {sPopupState.validation.params.username.msg}
                    </span>
                  </div>
                )}
            </div>
          </div>
          <div className="ens_item">
            <p>Password</p>
            <div className="err_msg_wrap">
              <input
                type="password"
                className="input_password"
                value={props.smtpSettings.password}
                onChange={e =>
                  props.changeNotificationSMTPSetting(
                    "password",
                    e.target.value
                  ) && updateValidation("password")
                }
                tabIndex={props.smtpSettings.isEnabled ? 0 : -1}
                autoComplete="new-password"
              />
              {props.smtpSettings.isEnabled &&
                !sPopupState.validation.status &&
                sPopupState.validation.params.password && (
                  <div>
                    <span className="error-msg active">
                      {sPopupState.validation.params.password.msg}
                    </span>
                  </div>
                )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SmtpSettings;
